import React from 'react';
import { View } from 'react-native';
import Text from 'design-system/Text';
import Spacer from 'design-system/Spacer';
import { rem } from 'design-system/values';
import { IconBoldArrow } from 'design-system/icons';
import IconCircle from 'design-system/icons/IconCircle';
import useStyles from 'hooks/useStyles';
import useColors from 'hooks/useColors';
import createStyleSheets from 'utils/createStyleSheets';
import { formatAmount } from 'utils/formatting';
import { getRangeString } from '../../utils/amounts';
const ARROW_ICON_SIZE = 44;
const strings = {
    currentDate: 'Current date',
    currentRange: 'Current range',
    newDate: 'New date',
    newRange: 'New range',
};
const AmountText = ({ value, currency, }) => <Text Numbers-14>{formatAmount(value, currency, null)}</Text>;
const formatAmountRange = (min, max, currency) => {
    if (min != null && max != null) {
        return (<>
        <AmountText value={min} currency={currency}/> to{' '}
        <AmountText value={max} currency={currency}/>
      </>);
    }
    if (max != null) {
        return (<>
        Up to <AmountText value={max} currency={currency}/>
      </>);
    }
    if (min != null) {
        return (<>
        From <AmountText value={min} currency={currency}/>
      </>);
    }
    return 'Any amount';
};
const Row = ({ label, value }) => {
    const styles = useStyles(styleSet);
    return (<View style={styles.row}>
      <Text TextThin-14 Secondary>
        {label}
      </Text>
      <Text Text-14>{value}</Text>
    </View>);
};
const MatchingRuleSuggestionContent = ({ subtitle, suggestions, currency, }) => {
    const styles = useStyles(styleSet);
    const colors = useColors();
    const { amount, monthDay } = suggestions;
    return (<View style={styles.container}>
      <Text TextThin-14 Gray centered>
        {subtitle}
      </Text>
      <Spacer.H16 />
      <View style={styles.card}>
        {monthDay ? (<Row label={strings.currentDate} value={getRangeString(monthDay.current.minMonthDay, monthDay.current.maxMonthDay)}/>) : null}
        {amount ? (<Row label={strings.currentRange} value={formatAmountRange(amount.current.minAmount, amount.current.maxAmount, currency)}/>) : null}
      </View>
      <View style={styles.arrowContainer} pointerEvents="none">
        <IconCircle width={ARROW_ICON_SIZE} height={ARROW_ICON_SIZE} color={colors.cards.onDark} style={styles.iconBorder}>
          <IconBoldArrow alt colorKey="brand" direction="bottom"/>
        </IconCircle>
      </View>
      <View style={styles.card}>
        {monthDay ? (<Row label={strings.newDate} value={getRangeString(monthDay.suggested.minMonthDay, monthDay.suggested.maxMonthDay)}/>) : null}
        {amount ? (<Row label={strings.newRange} value={formatAmountRange(amount.suggested.minAmount, amount.suggested.maxAmount, currency)}/>) : null}
      </View>
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    container: {
        width: '100%',
    },
    card: {
        backgroundColor: colors.cards.onLight,
        borderRadius: rem(16),
        padding: rem(16),
        gap: rem(24),
    },
    row: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    arrowContainer: {
        alignSelf: 'center',
        zIndex: 1,
        marginVertical: rem(-ARROW_ICON_SIZE / 3),
    },
    iconBorder: {
        borderWidth: 1,
        borderColor: colors.borders.divider,
    },
}));
export default MatchingRuleSuggestionContent;
